import {Button, Col, Form, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import API from "../api/api"
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";

function EditProfile() {
    const navigate = useNavigate();
    const params = useParams();
    const username = params.username;
    const loggedUsername = localStorage.getItem("username");
    const password = localStorage.getItem("password");
    const [user, setUser] = useState(false);

    if (username !== loggedUsername) {
        navigate("/");
        window.location.reload();
    }

    useEffect(() => {
        if (loggedUsername === username) {
            API.get("users/get-by-username?fetch-username=" + username, {
                headers: {
                    username: loggedUsername,
                    password: password
                }
            }).then(response => {
                setUser(response.data);
            })
        } else {
            API.get("users/get-by-username/public?fetch-username=" + username).then(response => {
                setUser(response.data);
            })
        }

    }, []);


    function handleEdit(event) {
        event.preventDefault();

        let formData = new FormData();
        formData.append("update-username", username);
        formData.append("firstname", event.target.firstname.value);
        formData.append("lastname", event.target.lastname.value);
        formData.append("birth_date", event.target.birthDate.value);
        formData.append("profile_picture", event.target.profilePicture.files[0]);
        console.log(loggedUsername);
        console.log(password);

        API.post("users/edit-user", formData, {
            headers: {
                username: loggedUsername,
                password: password,
                "Content-Type": "multipart/form-data"
            }
        }).then(response => {
            navigate("/users/" + user.username + "/profile");
            window.location.reload();
            window.location.reload();
        }).catch(error => {
            console.log(error);
        });
    }

    return (
        <div className="bg-gradient-dark text-white">
            {user && (
                <Container data-bs-theme="dark"
                           className="mt-5 pt-5 d-flex flex-column justify-content-centert align-items-center w-100">
                    <Row className="mb-5">
                        <Col>
                            <img src={user.profile_picture_url}
                                 alt="Profile Picture"
                                 height="100"
                                 width="100"
                                 className="d-inline-block align-top rounded-circle ratio-1x1"
                            />
                        </Col>
                        <Col>
                            <p className="display-3">{user.username}</p>
                        </Col>
                    </Row>
                    <Form onSubmit={handleEdit}>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formGridFirstname">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control defaultValue={user.firstname} name="firstname" type="firstname"
                                              placeholder="first name"/>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridLastname">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control defaultValue={user.lastname} name="lastname" type="lastname"
                                              placeholder="last name"/>
                            </Form.Group>
                        </Row>
                        <Form.Group className="mb-3" controlId="formGridPassword2">
                            <Form.Label>Birth Date</Form.Label>
                            <Form.Control defaultValue={user.birth_Date?user.birth_date.substring(0, 10):""} name="birthDate" type="date"
                                          placeholder="Birth Date"/>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formGridPassword2">
                            <Form.Label>Profile Picture</Form.Label>
                            <div className="d-flex">
                                <img src={user.profile_picture_url}
                                     alt="Profile Picture"
                                     height="50"
                                     width="50"
                                     className="d-inline-block align-top rounded-circle ratio-1x1"
                                />
                                <Form.Control name="profilePicture" type="file"
                                              placeholder="Profile Picture" accept=".png, .jpeg, .jpg" className="pl-2 m-5 mt-2 mb-2"/>
                            </div>
                        </Form.Group>
                        <Button variant="primary" type="submit">Save</Button>
                    </Form>
                </Container>
            )}
        </div>
    );
}

export default EditProfile;